/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
/**
 * Based on custom icon example:
 * https://atlassian.design/components/icon/custom-icon/examples
 */

import React, { type FC } from 'react';
import type { NewCoreIconProps } from '@atlaskit/icon/base-new';
import AssetsDataManagerIcon from '@atlaskit/icon-lab/core/assets-data-manager';

const JsmAssetsDataManagerIcon: FC<NewCoreIconProps> = (props) => (
	<AssetsDataManagerIcon {...props} />
);

export default JsmAssetsDataManagerIcon;
